import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col gap-4 p-4" }
const _hoisted_2 = { class: "flex items-center gap-2 text-sm text-gray-600" }
const _hoisted_3 = { class: "flex gap-6" }
const _hoisted_4 = { class: "w-64 border-r pr-4" }
const _hoisted_5 = { class: "space-y-2" }
const _hoisted_6 = { class: "flex-grow" }
const _hoisted_7 = { class: "prose" }

import { computed } from 'vue';
import { useRoute } from 'vue-router';
import TreeItem from '../components/Help/TreeViewItem.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'Help',
  setup(__props) {

const helpContent = {
  items: [
    {
      id: 'getting-started',
      title: 'Getting Started',
      children: [
        {
          id: 'quick-start',
          title: 'Quick Start Guide',
          content: 'This is the quick start guide content...'
        },
        {
          id: 'installation',
          title: 'Installation',
          content: 'Installation instructions go here...'
        }
      ]
    },
    {
      id: 'trading-basics',
      title: 'Trading Basics',
      children: [
        {
          id: 'charts',
          title: 'Understanding Charts',
          content: 'Learn about different chart types...'
        },
        {
          id: 'orders',
          title: 'Order Types',
          children: [
            {
              id: 'market-orders',
              title: 'Market Orders',
              content: 'Market order explanation...'
            },
            {
              id: 'limit-orders',
              title: 'Limit Orders',
              content: 'Limit order explanation...'
            }
          ]
        }
      ]
    }
  ]
};

const route = useRoute();

const findContent = (items: any[], path: string[]): any => {
  if (path.length === 0) return null;

  const currentId = path[0];
  const item = items.find(item => item.id === currentId);

  if (!item) return null;

  if (path.length === 1) {
    return item;
  }

  return findContent(item.children || [], path.slice(1));
};

const currentPath = computed(() => {
  return route.path.split('/').filter(segment => segment !== 'help');
});

const currentContent = computed(() => {
  const content = findContent(helpContent.items, currentPath.value);
  return content?.content || 'Please select a topic';
});

const breadcrumbs = computed(() => {
  const result: { title: string; path: string }[] = [];
  return result;
  /*
  const result: { title: string; path: string }[] = [];
  let currentItems = helpContent.items;
  let currentPath = '/help';

  for (const segment of currentPath.value) {
    const item = currentItems.find(item => item.id === segment);
    if (item) {
      currentPath += `/${segment}`;
      result.push({
        title: item.title,
        path: currentPath
      });
      currentItems = item.children || [];
    }
  }

  return result;
  */
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_router_link, {
        to: "/help",
        class: "hover:text-blue-600"
      }, {
        default: _withCtx(() => _cache[0] || (_cache[0] = [
          _createTextVNode("Help")
        ])),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(breadcrumbs.value, (crumb, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
          _cache[1] || (_cache[1] = _createElementVNode("span", null, ">", -1)),
          _createVNode(_component_router_link, {
            to: crumb.path,
            class: "hover:text-blue-600"
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(crumb.title), 1)
            ]),
            _: 2
          }, 1032, ["to"])
        ], 64))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(helpContent.items, (item) => {
            return (_openBlock(), _createBlock(TreeItem, {
              key: item.id,
              item: item,
              path: []
            }, null, 8, ["item"]))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, _toDisplayString(currentContent.value), 1)
      ])
    ])
  ]))
}
}

})